export enum ViewMode {
    OrgView = 1,
    SchoolView = 2,
}
